import e from "react";
import { c as v, t as _ } from "./app-a75c1d35.mjs";
import { B as n } from "./Block-9b78bd10.mjs";
const A = "video", f = "video__hero", g = "video__article", k = "desktop", P = "video__caption", d = {
  video: A,
  videoHero: f,
  videoArticle: g,
  desktop: k,
  videoCaption: P
};
var C = /* @__PURE__ */ ((t) => (t.ARTICLE = "videoArticle", t.HERO = "videoHero", t))(C || {});
function h({
  title: t,
  caption: s,
  styling: i,
  autoplay: l,
  embed: o,
  image: u = "",
  videoType: c,
  video: r,
  viewport: m
}) {
  const E = Array.isArray(r) ? r.find((y) => m && y.device?.includes(m)) : r, a = v(d.video, i && d[i]), p = /* @__PURE__ */ e.createElement(e.Fragment, null, c === "icareusIframe" && /* @__PURE__ */ e.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ), c === "embed" && (o?.includes("iframe") ? /* @__PURE__ */ e.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ) : /* @__PURE__ */ e.createElement(
    "video",
    {
      "data-testid": "videoplayer-embed",
      itemProp: "video",
      title: t,
      className: a,
      src: o,
      playsInline: !0,
      controls: !0
    },
    /* @__PURE__ */ e.createElement("track", { kind: "captions" })
  )), c === "asset" && /* @__PURE__ */ e.createElement(e.Fragment, null, l ? /* @__PURE__ */ e.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset",
      itemProp: "video",
      title: t,
      className: a,
      src: E?.src,
      autoPlay: l,
      loop: !0,
      muted: !0,
      playsInline: !0
    }
  ) : /* @__PURE__ */ e.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset-control",
      itemProp: "video",
      title: t,
      className: a,
      controls: !0,
      poster: u,
      playsInline: !0
    },
    !Array.isArray(r) && /* @__PURE__ */ e.createElement("source", { src: r.src, type: r.mimeType }),
    /* @__PURE__ */ e.createElement("track", { kind: "captions" })
  )));
  return i === "videoArticle" ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    n,
    {
      topPadding: n.Padding.SMALL,
      bottomPadding: n.Padding.LARGE,
      "data-testid": "article-video"
    },
    /* @__PURE__ */ e.createElement(n.Content, { "data-testid": "article-video-content" }, p, s && /* @__PURE__ */ e.createElement("p", { className: v(_.textsCaption, d.videoCaption) }, s))
  )) : p;
}
export {
  h as V,
  C as a
};
//# sourceMappingURL=Video-232035c2.mjs.map
